import { render, staticRenderFns } from "./DueItemPage.vue?vue&type=template&id=42eadf0c&"
import script from "./DueItemPage.vue?vue&type=script&lang=js&"
export * from "./DueItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports